import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

// メールのリンクで受け取る使い捨てのトークン（reset_password_token /
// confirmation_token）を読み、すぐに URL から消す（PR #443 のレビュー M1）。
//
// URL に残すと、mixpanel-browser が全イベントに付ける `$current_url` に載って
// 外部へ送られるほか、アドレスバー・履歴にも残る。**このページの trackEvent は
// この hook の effect より後に置くこと**（effect は宣言順に走る）。
//
// トークンは最初の描画のときに state に取り込むので、URL から消したあとも画面は使える。
export const useOneTimeTokenFromUrl = (param: string): string => {
  const history = useHistory()
  const location = useLocation()
  const [token] = useState(
    () => new URLSearchParams(window.location.search).get(param) ?? "",
  )

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    if (!searchParams.has(param)) return

    searchParams.delete(param)
    const search = searchParams.toString()
    history.replace({
      pathname: location.pathname,
      search: search ? `?${search}` : "",
      hash: location.hash,
    })
  }, [])

  return token
}
